import { useCallback, useState } from "react";

function read(key, choices, fallback) {
  try {
    const stored = JSON.parse(window.localStorage.getItem(key));
    return choices.includes(stored) ? stored : fallback;
  } catch {
    return fallback; // blocked storage (private window), or junk
  }
}

/**
 * One of a fixed set of `choices`, remembered in this browser — a viewer's
 * preference like "24 per page", not part of a page's address. Anything
 * stored that isn't a choice (an old option, junk, another tab's typo)
 * reads as `fallback`; storage that refuses (private windows) just means
 * it isn't remembered.
 */
export default function useStoredChoice(key, choices, fallback) {
  const [value, setValue] = useState(() => read(key, choices, fallback));
  const choose = useCallback(
    (next) => {
      setValue(next);
      try {
        window.localStorage.setItem(key, JSON.stringify(next));
      } catch {
        // not remembered; the choice still applies to this visit
      }
    },
    [key],
  );
  return [value, choose];
}
